<template>
  <div :class="['modal', { 'is-active': show }]">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Create Appointment</p>
        <button class="delete" @click="$emit('hide')"></button>
      </header>
      <section class="modal-card-body">
        <schedule-form
          :encounter="encounter"
          :errors="errors"
          label="Schedule"
          :onSubmit="onSubmit"
          @hide="$emit('hide')"
        >
        </schedule-form>
        <vue-toastr ref="toastr"></vue-toastr>
      </section>
    </div>
  </div>
</template>

<script>
/* eslint func-names: ["error", "never"] */

import EncountersService from "@/services/EncountersService";
import ScheduleForm from "./ScheduleForm";

export default {
  name: "schedule-create",

  components: {
    ScheduleForm
  },

  data() {
    return {
      loading: false,
      encounter: {
        patient: null,
        date: null,
        time: null,
        duration: 15,
        provider: null,
        reasonForVisit: null,
        reviewOfSystems: []
      },
      errors: {}
    };
  },

  computed: {
    show() {
      this.encounter = { patient: null, date: null, duration: 15 };
      return this.$store.getters["encounter/showScheduler"];
    }
  },

  methods: {
    onSubmit(formValues) {
      this.loading = true;

      EncountersService.create(formValues)
        .then(() => {
          this.loading = false;
          this.$refs.toastr.s("The visit has been created.");
          this.$emit("added");
          this.$emit("hide");
        })
        .catch(errors => {
          this.loading = false;
          const e = errors.response.data.errors[0].detail[0];
          this.$refs.toastr.e(e.detail);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
